import { LoanCondiciones } from "@interfaces/response";

export const EJEMPLO_DIAS = 60;

export function getOfertaFluxValues(condition: LoanCondiciones | null) {
  const lineaPreaprobada = condition?.approved_amount ?? 0;
  const aforo = condition?.extra_conditions?.factoring?.advance_rate ?? 0;
  const tasa = condition?.interest_rate ?? 0;
  const comision = condition?.extra_conditions?.factoring?.operation_fee ?? 0;
  const plazoMax = condition?.approved_max_term ?? 0;
  const facturaEjemplo = condition?.extra_conditions?.factoring?.sample_document_amount ?? 0;
  const anticipo = (facturaEjemplo * aforo) / 100;
  const costoEjemplo = anticipo * (tasa / 100) * (EJEMPLO_DIAS / 360) + facturaEjemplo * (comision / 100);
  return { lineaPreaprobada, aforo, tasa, comision, plazoMax, facturaEjemplo, anticipo, costoEjemplo };
}
